import React from 'react';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import SidebarContent from './Sidebar';

const SidebarPicker = () => {
  const { pageContentResource } = usePageContentContext();

  if (pageContentResource.attr('sidebarTabs')) {
    return (
      <SidebarContent />
    );
  }

  return null;
};

export default SidebarPicker;
